// @flow
import TargetInspectorContainer from './containers/TargetInspectorContainer';

export default TargetInspectorContainer;